interface Props {
  thumbnail: {
    mobile: string;
    pc: string;
  };
  onClick: () => void;
}

const CharacterItem = ({ thumbnail, onClick }: Props) => {
  return (
    <div
      className='character-item'
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <picture>
        <source media='(max-width: 1023px)' srcSet={thumbnail.mobile} />
        <img src={thumbnail.pc} alt='Ngao Bái' />
      </picture>
    </div>
  );
};

export default CharacterItem;
